import { useEffect, useState } from 'react'
import useAxios from '../../hooks/useAxios'
import { PaginationResponseInterface } from '../../types/pagination'
import SelectSearchMultiple, { IOptionSelect } from '../SelectSearchMultiple'
import SelectSearch from '.'
import { IDistributionChannel } from '../../types/distribution-channel'
import { ImageLinks, LogoTypeSocial } from '../../constants/image-link'

interface Props {
  handleFilterChange?: (filter: any) => void
  selected?: string[]
  onSelect: (e: any) => void
  resetAutoComplete?: string
  label?: string
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  helperText?: string | any
  error?: boolean | any
  name?: string
  multiple?: boolean
  defaultValue?: any
}

const ChannelSelectSearch = (props: Props) => {
  const {
    handleFilterChange,
    selected,
    onSelect,
    resetAutoComplete = '',
    label = 'เลือกช่องทางการขาย',
    multiple = true,
    ...rest
  } = props
  const [search, setSearch] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [debouncedSearch, setDebouncedSearch] = useState<string>(search)

  const { data, isLoading } = useAxios<
    PaginationResponseInterface<IDistributionChannel>
  >({
    method: 'GET',
    url: '/distribution-channels',
    params: {
      page: 1,
      perPage: 15,
      search: debouncedSearch,
      startDate: '',
      endDate: '',
      hideInActive: true,
    },
  })

  useEffect(() => {
    setLoading(true)
    const handler = setTimeout(() => {
      setDebouncedSearch(search)
      setLoading(false)
    }, 1000)

    return () => {
      clearTimeout(handler)
      setLoading(false)
    }
  }, [search])

  const handleSearch = async (value: string) => {
    setSearch(value)
  }

  const currentLoadingState = loading || isLoading

  return (
    <>
      {multiple ? (
        <SelectSearchMultiple<IDistributionChannel>
          resetAutoComplete={resetAutoComplete}
          label={`${label} ${currentLoadingState ? 'กำลังโหลด...' : ''}`}
          onSelect={onSelect}
          search={search}
          onSearch={handleSearch}
          options={
            data?.records
              .filter(
                (distributionChannel: IDistributionChannel) =>
                  !selected?.includes(distributionChannel.objectId),
              )
              .map((distributionChannel: IDistributionChannel) => ({
                label: distributionChannel.name,
                value: distributionChannel,
                image:
                  ImageLinks[
                    `LOGO_${distributionChannel.type.toUpperCase()}` as LogoTypeSocial
                  ],
              })) || ([] as IOptionSelect<IDistributionChannel>[])
          }
        />
      ) : (
        <SelectSearch<IDistributionChannel>
          {...rest}
          resetAutoComplete={resetAutoComplete}
          label={`${label} ${currentLoadingState ? 'กำลังโหลด...' : ''}`}
          onSelect={onSelect}
          search={search}
          onSearch={handleSearch}
          options={
            data?.records.map((distributionChannel: IDistributionChannel) => ({
              label: distributionChannel.name,
              image:
                ImageLinks[
                  `LOGO_${distributionChannel.type.toUpperCase()}` as LogoTypeSocial
                ],
              value: distributionChannel,
            })) || ([] as IOptionSelect<IDistributionChannel>[])
          }
        />
      )}
    </>
  )
}

export default ChannelSelectSearch
